"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _withIconProps = require("../utils/withIconProps");
var _react2 = require("@emotion/react");
/**
 * This file generated by Stencil generateIcons scripts
 * DO NOT EDIT DIRECTLY
 */

const IconAlertTriangleFillExtraSmall = (0, _withIconProps.withIconProps)(props => {
  return (0, _react2.jsx)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: "16px",
    height: "16px"
  }, props), (0, _react2.jsx)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2C8.36594 2 8.70266 2.19989 8.8779 2.52115L14.8779 13.5211C15.0469 13.831 15.0401 14.207 14.8599 14.5105C14.6797 14.814 14.3529 15 14 15H2C1.64706 15 1.32026 14.814 1.1401 14.5105C0.95994 14.207 0.9531 13.831 1.1221 13.5211L7.1221 2.52115C7.29734 2.19989 7.63406 2 8 2ZM8 5C8.55228 5 9 5.44772 9 6V9C9 9.55228 8.55228 10 8 10C7.44772 10 7 9.55228 7 9V6C7 5.44772 7.44772 5 8 5ZM9 12C9 12.5523 8.55228 13 8 13C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11C8.55228 11 9 11.4477 9 12Z",
    fill: "currentColor"
  }));
}, 'IconAlertTriangleFillExtraSmall');
IconAlertTriangleFillExtraSmall.displayName = 'IconAlertTriangleFillExtraSmall';
var _default = exports.default = IconAlertTriangleFillExtraSmall;